import * as React from 'react';
import { UIHeading3, UIText1 } from '@cian/ui-kit';
import * as styles from './Header.css';

interface IHeaderProps {
  title: string;
  description?: string;
}

export const Header = (props: IHeaderProps) => {
  return (
    <div className={styles['header']}>
      <div className={styles['logo']} />
      <div className={styles['title']}>
        <UIHeading3 textAlign="center">{props.title}</UIHeading3>
        <UIText1 textAlign="center">{props.description}</UIText1>
      </div>
    </div>
  );
};
